import React from 'react';
import { Check, X, Save, Trash2, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';

const AttendanceToolbar = ({ selectedCount, onPresent, onAbsent, onRegister, onClear, onExit }) => (
  <div
    className="flex flex-wrap items-center gap-2 px-4 py-3 border-b bg-yellow-50"
    data-testid="attendance-toolbar"
  >
    <Button
      type="button"
      size="sm"
      data-testid="toolbar-present"
      onClick={onPresent}
      disabled={selectedCount === 0}
      className="rounded-full text-xs font-bold gap-1.5"
      style={{ background: '#22c55e', color: '#fff' }}
    >
      <Check size={14} /> Närvarande
    </Button>
    <Button
      type="button"
      size="sm"
      data-testid="toolbar-absent"
      onClick={onAbsent}
      disabled={selectedCount === 0}
      className="rounded-full text-xs font-bold gap-1.5"
      style={{ background: '#ef4444', color: '#fff' }}
    >
      <X size={14} /> Frånvarande
    </Button>
    <Button
      type="button"
      size="sm"
      data-testid="toolbar-register"
      onClick={onRegister}
      disabled={selectedCount === 0}
      className="rounded-full text-xs font-bold gap-1.5"
      style={{ background: '#F9CF3F', color: '#333333' }}
    >
      <Save size={14} /> Registrera markerade
    </Button>
    <Button
      type="button"
      size="sm"
      variant="ghost"
      data-testid="toolbar-clear"
      onClick={onClear}
      className="rounded-full text-xs font-bold gap-1.5"
    >
      <Trash2 size={14} /> Rensa
    </Button>
    <div className="flex-1" />
    <Button
      type="button"
      size="sm"
      variant="outline"
      data-testid="toolbar-exit"
      onClick={onExit}
      className="rounded-full text-xs font-bold gap-1.5"
    >
      <LogOut size={14} /> Avsluta
    </Button>
    {selectedCount > 0 && (
      <span className="text-xs text-muted-foreground" data-testid="selected-count">
        {selectedCount} markerade
      </span>
    )}
  </div>
);

export default AttendanceToolbar;
